import type { MigrationManifest } from 'redux-persist'

import { clearAction } from './clearAction'
import { clearAddressBook } from './clearAddressBook'
import { clearAssets } from './clearAssets'
import { clearLocalWallet } from './clearLocalWallet'
import { clearMarketData } from './clearMarketData'
import { clearOpportunities } from './clearOpportunities'
import { clearPortfolio } from './clearPortfolio'
import { clearSnapshot } from './clearSnapshot'
import { clearSwaps } from './clearSwaps'
import { clearTxHistory } from './clearTxHistory'
export const clearTxHistoryMigrations = {
  0: clearTxHistory,
  1: clearTxHistory,
  2: clearTxHistory,
  3: clearTxHistory,
  4: clearTxHistory,
  5: clearTxHistory,
  6: clearTxHistory,
  7: clearTxHistory,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearOpportunitiesMigrations = {
  0: clearOpportunities,
  1: clearOpportunities,
  2: clearOpportunities,
  3: clearOpportunities,
  4: clearOpportunities,
  5: clearOpportunities,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearPortfolioMigrations = {
  0: clearPortfolio,
  1: clearPortfolio,
  2: clearPortfolio,
  3: clearPortfolio,
  4: clearPortfolio,
} as unknown as Omit<MigrationManifest, '_persist'>

export const localWalletMigrations = {
  0: clearLocalWallet,
  1: clearLocalWallet,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearAssetsMigrations = {
  0: clearAssets,
  1: clearAssets,
  2: clearAssets,
  3: clearAssets,
  4: clearAssets,
  5: clearAssets,
  6: clearAssets,
  7: clearAssets,
  8: clearAssets,
  9: clearAssets,
  10: clearAssets,
  11: clearAssets,
  12: clearAssets,
  13: clearAssets,
  14: clearAssets,
  15: clearAssets,
  16: clearAssets,
  17: clearAssets,
  18: clearAssets,
  19: clearAssets,
  20: clearAssets,
  21: clearAssets,
  22: clearAssets,
  23: clearAssets,
  24: clearAssets,
  25: clearAssets,
  26: clearAssets,
  27: clearAssets,
  28: clearAssets,
  29: clearAssets,
  30: clearAssets,
  31: clearAssets,
  32: clearAssets,
  33: clearAssets,
  34: clearAssets,
  35: clearAssets,
  36: clearAssets,
  37: clearAssets,
  38: clearAssets,
  39: clearAssets,
  40: clearAssets,
  41: clearAssets,
  42: clearAssets,
  43: clearAssets,
  44: clearAssets,
  45: clearAssets,
  46: clearAssets,
  47: clearAssets,
  48: clearAssets,
  49: clearAssets,
  50: clearAssets,
  51: clearAssets,
  52: clearAssets,
  53: clearAssets,
  54: clearAssets,
  55: clearAssets,
  56: clearAssets,
  57: clearAssets,
  58: clearAssets,
  59: clearAssets,
  60: clearAssets,
  61: clearAssets,
  62: clearAssets,
  63: clearAssets,
  64: clearAssets,
  65: clearAssets,
  66: clearAssets,
  67: clearAssets,
  68: clearAssets,
  69: clearAssets,
  70: clearAssets,
  71: clearAssets,
  72: clearAssets,
  73: clearAssets,
  74: clearAssets,
  75: clearAssets,
  76: clearAssets,
  77: clearAssets,
  78: clearAssets,
  79: clearAssets,
  80: clearAssets,
  81: clearAssets,
  82: clearAssets,
  83: clearAssets,
  84: clearAssets,
  85: clearAssets,
  86: clearAssets,
  87: clearAssets,
  88: clearAssets,
  89: clearAssets,
  90: clearAssets,
  91: clearAssets,
  92: clearAssets,
  93: clearAssets,
  94: clearAssets,
  95: clearAssets,
  96: clearAssets,
  97: clearAssets,
  98: clearAssets,
  99: clearAssets,
  100: clearAssets,
  101: clearAssets,
  102: clearAssets,
  103: clearAssets,
  104: clearAssets,
  105: clearAssets,
  106: clearAssets,
  107: clearAssets,
  108: clearAssets,
  109: clearAssets,
  110: clearAssets,
  111: clearAssets,
  112: clearAssets,
  113: clearAssets,
  114: clearAssets,
  115: clearAssets,
  116: clearAssets,
  117: clearAssets,
  118: clearAssets,
  119: clearAssets,
  120: clearAssets,
  121: clearAssets,
  122: clearAssets,
  123: clearAssets,
  124: clearAssets,
  125: clearAssets,
  126: clearAssets,
  127: clearAssets,
  128: clearAssets,
  129: clearAssets,
  130: clearAssets,
  131: clearAssets,
  132: clearAssets,
  133: clearAssets,
  134: clearAssets,
  135: clearAssets,
  136: clearAssets,
  137: clearAssets,
  138: clearAssets,
  139: clearAssets,
  140: clearAssets,
  141: clearAssets,
  142: clearAssets,
  143: clearAssets,
  144: clearAssets,
  145: clearAssets,
  146: clearAssets,
  147: clearAssets,
  148: clearAssets,
  149: clearAssets,
  150: clearAssets,
  151: clearAssets,
  152: clearAssets,
  153: clearAssets,
  154: clearAssets,
  155: clearAssets,
  156: clearAssets,
  157: clearAssets,
  158: clearAssets,
  159: clearAssets,
  160: clearAssets,
  161: clearAssets,
  162: clearAssets,
  163: clearAssets,
  164: clearAssets,
  165: clearAssets,
  166: clearAssets,
  167: clearAssets,
  168: clearAssets,
  169: clearAssets,
  170: clearAssets,
  171: clearAssets,
  172: clearAssets,
  173: clearAssets,
  174: clearAssets,
  175: clearAssets,
  176: clearAssets,
  177: clearAssets,
  178: clearAssets,
  179: clearAssets,
  180: clearAssets,
  181: clearAssets,
  182: clearAssets,
  183: clearAssets,
  184: clearAssets,
  185: clearAssets,
  186: clearAssets,
  187: clearAssets,
  188: clearAssets,
  189: clearAssets,
  190: clearAssets,
  191: clearAssets,
  192: clearAssets,
  193: clearAssets,
  194: clearAssets,
  195: clearAssets,
  196: clearAssets,
  197: clearAssets,
  198: clearAssets,
  199: clearAssets,
  200: clearAssets,
  201: clearAssets,
  202: clearAssets,
  203: clearAssets,
  204: clearAssets,
  205: clearAssets,
  206: clearAssets,
  207: clearAssets,
  208: clearAssets,
  209: clearAssets,
  210: clearAssets,
  211: clearAssets,
  212: clearAssets,
  213: clearAssets,
  214: clearAssets,
  215: clearAssets,
  216: clearAssets,
  217: clearAssets,
  218: clearAssets,
  219: clearAssets,
  220: clearAssets,
  221: clearAssets,
  222: clearAssets,
  223: clearAssets,
  224: clearAssets,
  225: clearAssets,
  226: clearAssets,
  227: clearAssets,
  228: clearAssets,
  229: clearAssets,
  230: clearAssets,
  231: clearAssets,
  232: clearAssets,
  233: clearAssets,
  234: clearAssets,
  235: clearAssets,
  236: clearAssets,
  237: clearAssets,
  238: clearAssets,
  239: clearAssets,
  240: clearAssets,
  241: clearAssets,
  242: clearAssets,
  243: clearAssets,
  244: clearAssets,
  245: clearAssets,
  246: clearAssets,
  247: clearAssets,
  248: clearAssets,
  249: clearAssets,
  250: clearAssets,
  251: clearAssets,
  252: clearAssets,
  253: clearAssets,
  254: clearAssets,
  255: clearAssets,
  256: clearAssets,
  257: clearAssets,
  258: clearAssets,
  259: clearAssets,
  260: clearAssets,
  261: clearAssets,
  262: clearAssets,
  263: clearAssets,
  264: clearAssets,
  265: clearAssets,
  266: clearAssets,
  267: clearAssets,
  268: clearAssets,
  269: clearAssets,
  270: clearAssets,
  271: clearAssets,
  272: clearAssets,
  273: clearAssets,
  274: clearAssets,
  275: clearAssets,
  276: clearAssets,
  277: clearAssets,
  278: clearAssets,
  279: clearAssets,
  280: clearAssets,
  281: clearAssets,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearMarketDataMigrations = {
  0: clearMarketData,
  1: clearMarketData,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearSnapshotMigrations = {
  0: clearSnapshot,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearActionMigrations = {
  0: clearAction,
  1: clearAction,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearSwapsMigrations = {
  0: clearSwaps,
} as unknown as Omit<MigrationManifest, '_persist'>

export const clearAddressBookMigrations = {
  0: clearAddressBook,
} as unknown as Omit<MigrationManifest, '_persist'>
